<template>
	<h5>No view for tab {{ $route.name }}</h5>
</template>

<script>
export default {
	name: 'MissingSettings',
};
</script>

<style scoped></style>
